import {DialogActions, DialogContent, Typography} from '@mui/material';

import useEmmai from '../../../../../hooks/providers/useEmmai';
import Button from '../../../../form/buttons/Button/Button';
import BaseModal from '../../../../modal/BaseModal';

const WarningActivityDataWillBeLostOnMonthChangeModal = () => {
  const {
    pendingDate,
    setPendingDate,
    setEmmaiRestitutionSelectedDate,
    warningActivityDataWillBeLostOnMonthChangeModalOpen: isOpen,
    setWarningActivityDataWillBeLostOnMonthChangeModalOpen: setIsOpen
  } = useEmmai();

  const onClose = () => setIsOpen(false);

  const onSubmit = () => {
    if (pendingDate) {
      setEmmaiRestitutionSelectedDate(pendingDate);
      setPendingDate(null);
    }
    setIsOpen(false);
  };

  return (
    <BaseModal onClose={onClose} open={isOpen} title="Sauvegarder les modifications">
      <DialogContent sx={{p: 3}}>
        <Typography>Vous êtes sur le point de quitter la saisie pour le mois en cours. Vous perdrez toutes les modifications non sauvegardées.</Typography>
      </DialogContent>
      <DialogActions sx={{width: '90%', margin: 'O auto'}}>
        <Button variant="outlined" onClick={onClose}>
          Annuler
        </Button>
        <Button variant="contained" color="error" onClick={onSubmit}>
          Quitter sans sauvegarder
        </Button>
      </DialogActions>
    </BaseModal>
  );
};

export default WarningActivityDataWillBeLostOnMonthChangeModal;
